import { render, staticRenderFns } from "./TransferReceiptVoucherDisplayView.vue?vue&type=template&id=60f38182"
import script from "./TransferReceiptVoucherDisplayView.vue?vue&type=script&lang=js"
export * from "./TransferReceiptVoucherDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports